import React, { useEffect, useState } from 'react'
import CustomAgGrid from './../../components/shared/CustomAgGrid'
import { CForm, CFormLabel, CFormInput, CFormSelect, CSpinner, CButton, CRow, CCol, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter } from '@coreui/react'
import fetchPatientData from '../../services/general/patientGeneralAPI.api.js'
import Pageloader from '../../components/shared/Pageloader'

const InsuranceForm = () => {
  const [groupName, setGroupName] = useState('')
  const [name, setName] = useState('')
  const [type, setType] = useState('Commercial')
  const [parent, setParent] = useState('')
  const [modalVisible, setModalVisible] = useState(false)
  const [insuranceList, setInsuranceList] = useState([])
  const [isDataRefetched, setDataRefetched] = useState(false)
  const [loading, setLoading] = useState(true) // Added loading state
  const [editIndex, setEditIndex] = useState(null) // Added state to track the index of the insurance being edited
  const buttonList = [{ Name: 'Edit' }, { Name: 'Delete' }]
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [isPageLoading, setIsPageLoading] = useState(false)

  const typeOptions = ['Medicare Traditional', 'Medicare Out of Pocket', 'Medicare Supplemental', 'Medicare Advantage', 'Medicaid', 'Railroad', 'Private', 'Self Pay']

  const handleOnClick = (type, e) => {
    if (type == 'EDIT') {
      handleEditInsurance(e)
    } else if (type == 'DELETE') {
      setDeleteVisibleId(e)
    }
  }

  const handleDeleteInsurance = async (e) => {
    await fetchPatientData('DELETE', 'Insurance', JSON.stringify({ id: deleteVisibleId?.ID }))
    handleInsuranceData()
    setDeleteVisibleId(null)
  }

  const handleTypeSelect = (e) => {
    setType(e.target.value)
  }

  const handleParentSelect = (e) => {
    setParent(e.target.value)
  }

  const handleInsuranceData = async () => {
    setIsPageLoading(true)
    let insuranceData = await fetchPatientData('GET', 'Insurance', '{}')
    insuranceData = JSON.parse(insuranceData.d)?.Data
    // Simulate fetching data
    setInsuranceList(insuranceData)
    setIsPageLoading(false) // Data fetching complete, stop the spinner
  }

  useEffect(() => {
    handleInsuranceData()
  }, [])

  const handleAddInsurance = () => {
    setGroupName('')
    setName('')
    setType('')
    setParent('')
    setEditIndex(null)
    setModalVisible(true)
  }

  const handleEditInsurance = (insurance) => {
    setGroupName(insurance?.Group)
    setName(insurance?.SubType)
    setType(insurance?.Type)
    setParent(insurance?.Parent)
    setEditIndex(insurance?.ID) // Track the index of the insurance being edited
    setModalVisible(true)
  }

  const handleSaveInsurance = async () => {
    if (editIndex !== null) {
      const newInsurance = { ID: editIndex, Group: groupName, Name: name, Type: type, Parent: parent }
      await fetchPatientData('UPDATE', 'Insurance', JSON.stringify(newInsurance))
      // Update the existing insurance entry
    } else {
      const newInsurance = { Group: groupName, Name: name, Type: type, Parent: parent }

      // Add a new insurance entry
      await fetchPatientData('INSERT', 'Insurance', JSON.stringify(newInsurance))
    }

    // const updatedList = [...insuranceList];
    //   updatedList[editIndex] = newInsurance;
    //   setInsuranceList(updatedList);

    await handleInsuranceData()

    setModalVisible(false)
    setGroupName('')
    setName('')
    setType('')
    setParent('')
    setEditIndex(null)
  }

  return (
    <>
      <div className="position-relative patient-theme-page insurance-master-theme">
        <div className="patient-page-wrapper page-wrapper patient-theme-shell dashboard-dark-theme">
          <Pageloader isLoading={isPageLoading} />
          <CCard className="m-2 master-grid-theme__toolbar">
            <CCardBody className="w-100 master-grid-theme__toolbar-body">
              <CRow>
                <CCol sm={4}>
                  <CButton onClick={handleAddInsurance} className="ui-action-btn ui-action-btn--primary">
                    + Add Insurance
                  </CButton>
                </CCol>
                <CCol></CCol>
              </CRow>
            </CCardBody>
          </CCard>

          <CustomAgGrid className="insurance-master-theme__grid" rowClickedFn={handleOnClick} callFrom="Insurance" options={insuranceList} btnList={buttonList} />

          <CModal size="lg" scrollable visible={modalVisible} backdrop={'static'} onClose={() => setModalVisible(false)} className="patient-theme-modal">
            <CModalHeader onClose={() => setModalVisible(false)}>
              <CModalTitle>{editIndex !== null ? 'Edit Insurance' : 'Add Insurance'}</CModalTitle>
            </CModalHeader>
            <CModalBody>
              <CForm>
                <CRow className="mb-3">
                  <CCol xs="6" className="mb-3">
                    <CFormLabel>Type</CFormLabel>
                    <CFormSelect id="type" value={type} onChange={handleTypeSelect}>
                      {typeOptions.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>

                  <CCol xs="6">
                    <CFormLabel>Sub Type</CFormLabel>
                    <CFormInput type="text" id="name" placeholder="Enter name" value={name} onChange={(e) => setName(e.target.value)} />
                  </CCol>
                </CRow>
              </CForm>
            </CModalBody>
            <CModalFooter>
              <CButton color="secondary" className="ui-action-btn ui-action-btn--secondary" onClick={() => setModalVisible(false)}>
                Close
              </CButton>
              <CButton className="ui-action-btn ui-action-btn--primary" onClick={handleSaveInsurance}>
                {editIndex !== null ? 'Save Changes' : 'Add Insurance'}
              </CButton>
            </CModalFooter>
          </CModal>

          <CModal visible={!!deleteVisibleId} className="patient-theme-modal" onClose={() => setDeleteVisibleId(null)}>
            <CModalHeader onClose={() => setDeleteVisibleId(null)}>
              <CModalTitle>Warning</CModalTitle>
            </CModalHeader>
            <CModalBody>
              <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
            </CModalBody>
            <hr className="p-0 m-0" />
            <CModalFooter className="p-3 m-0">
              <CButton
                color="secondary"
                onClick={() => {
                  setDeleteVisibleId(null)
                }}
                className="ui-action-btn ui-action-btn--secondary"
              >
                Close
              </CButton>
              <CButton onClick={handleDeleteInsurance} className="ui-action-btn ui-action-btn--delete">
                Delete
              </CButton>
            </CModalFooter>
          </CModal>
        </div>
      </div>
    </>
  )
}

export default InsuranceForm
